export enum CertificateOfOccupancyType {
    Yes = 0,
    No = 1,
    TCO = 2,
    LocalEquivalent = 3,
}
